module.exports = __webpack_public_path__ + "static/media/bird5.fd5aebef.svg";